<p class="mt-4 pb-2 font-bold text-xs">
  {{ 'cases' | translateVertical }}
</p>

@if (loading) {
  <maximizer-outlook-skeleton
    containerClasses="h-[120px] w-full rounded-md bg-neutral-25"
  ></maximizer-outlook-skeleton>
} @else if (!configuration.case) {
  <p class="text-body pb-8">
    {{
      'outlook.summary.case.emptyState'
        | translate
          : {
              label: 'cases' | translateVertical,
            }
    }}
  </p>
} @else {
  <div class="mt-2 text-xs space-y-2">
    <div
      class="bg-white w-full rounded border border-neutral-20 flex flex-col p-2 pl-2 mb-2 justify-around"
    >
      <div class="flex flex-row">
        <div class="flex-shrink-0">
          <span
            class="mr-1 my-auto svg-icons icon-case icon-12 text-neutral-70"
          ></span>
        </div>
        <div class="flex-1 flex flex-col min-w-0">
          <span
            class="font-bold my-auto text-ellipsis overflow-hidden whitespace-nowrap mb-2"
          >
            {{ configuration.case.subject }}</span
          >

          <span
            class="text-body bold text-neutral-90 text-ellipsis overflow-hidden whitespace-nowrap mb-2"
          >
            {{ configuration.case.companyName }}</span
          >

          @if (configuration.case.status) {
            <div class="flex flex-row">
              <span class="text-neutral-90 mr-1"
                >{{ 'outlook.case.status' | translate }}:
              </span>
              <span class="text-neutral-70">{{
                configuration.case.status
              }}</span>
            </div>
          }

          @if (configuration.case.priority) {
            <div class="flex flex-row">
              <span class="text-neutral-90 mr-1"
                >{{ 'outlook.case.priority' | translate }}:
              </span>
              <span class="text-neutral-70">{{
                configuration.case.priority
              }}</span>
            </div>
          }

          @if (configuration.case.caseNumber) {
            <div class="flex flex-row">
              <span class="text-neutral-90 mr-1"
                >{{ 'case' | translateVertical }}:
              </span>
              <span class="text-neutral-70">{{
                configuration.case.caseNumber
              }}</span>
            </div>
          }

          @let contact = configuration.case.contact;
          @if (contact?.firstName || contact?.lastName) {
            <div
              class="flex flex-row text-ellipsis overflow-hidden whitespace-nowrap"
            >
              <span class="text-neutral-90 mr-1"
                >{{ 'outlook.case.contact' | translate }}:
              </span>
              <span class="text-neutral-70"
                >{{ contact?.firstName }} {{ contact?.lastName }}</span
              >
            </div>
          }

          @if (configuration.case.assignedTo) {
            <div
              class="text-neutral-90 mr-1 text-ellipsis overflow-hidden whitespace-nowrap"
            >
              <span class="text-neutral-90 mr-1"
                >{{ 'outlook.case.assignedTo' | translate }}:
              </span>
            </div>
            <div class="flex items-center gap-2">
              <span class="avatar avatar-xxs bg-inserv-10">{{
                configuration.case.assignedTo | nameInitials
              }}</span>
              <span class="text-neutral-90">{{
                configuration.case.assignedTo
              }}</span>
            </div>
          }

          <p class="text-neutral-70 line-clamp-4">
            {{ configuration.case.description }}
          </p>

          <div class="flex flex-row">
            <span class="ml-auto caption text-neutral-70 pt-1">{{
              configuration.case.lastModifyDate
                | date: outlookStore.fullDateTimeFormat()
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <span class="text-neutral-70">
      {{ configuration.casesAmount }}
      @if (configuration.casesAmount === 1) {
        {{
          'outlook.summary.case.amount'
            | translate
              : {
                  label: 'case' | translateVertical,
                }
        }}
      } @else {
        {{
          'outlook.summary.case.amount'
            | translate
              : {
                  label: 'cases' | translateVertical,
                }
        }}
      }
    </span>
    <a
      id="outlook-case-ui-summaryCase-more"
      class="underline text-link"
      [href]="deepLink()"
      target="_blank"
      rel="noopener"
      >{{ 'outlook.summary.openInMaximizer' | translate }}</a
    >
  </div>
}
